import { CurrencyEuroIcon, DocumentTextIcon, ClockIcon, CalendarIcon, EyeIcon, UserGroupIcon, AcademicCapIcon, HomeIcon, GlobeEuropeAfricaIcon, ClipboardDocumentCheckIcon, NewspaperIcon, FlagIcon, ClipboardIcon } from '@heroicons/react/24/outline';
import { getAssetSrc } from '../utils/assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var listIconMap = {
  CurrencyEuroIcon: /*#__PURE__*/_jsx(CurrencyEuroIcon, {
    className: "h-5 w-5"
  }),
  turnover_bonus: /*#__PURE__*/_jsx(CurrencyEuroIcon, {
    className: "h-5 w-5"
  }),
  DocumentTextIcon: /*#__PURE__*/_jsx(DocumentTextIcon, {
    className: "h-5 w-5"
  }),
  ClockIcon: /*#__PURE__*/_jsx(ClockIcon, {
    className: "h-5 w-5"
  }),
  CalendarIcon: /*#__PURE__*/_jsx(CalendarIcon, {
    className: "h-5 w-5"
  }),
  EyeIcon: /*#__PURE__*/_jsx(EyeIcon, {
    className: "h-5 w-5"
  }),
  UserGroupIcon: /*#__PURE__*/_jsx(UserGroupIcon, {
    className: "h-5 w-5"
  }),
  AcademicCapIcon: /*#__PURE__*/_jsx(AcademicCapIcon, {
    className: "h-5 w-5"
  }),
  continuous_training: /*#__PURE__*/_jsx(AcademicCapIcon, {
    className: "h-5 w-5"
  }),
  HomeIcon: /*#__PURE__*/_jsx(HomeIcon, {
    className: "h-5 w-5"
  }),
  seasonal_accommodation: /*#__PURE__*/_jsx(HomeIcon, {
    className: "h-5 w-5"
  }),
  GlobeEuropeAfricaIcon: /*#__PURE__*/_jsx(GlobeEuropeAfricaIcon, {
    className: "h-5 w-5"
  }),
  paid_trips: /*#__PURE__*/_jsx(GlobeEuropeAfricaIcon, {
    className: "h-5 w-5"
  }),
  NewspaperIcon: /*#__PURE__*/_jsx(NewspaperIcon, {
    className: "h-5 w-5"
  }),
  FlagIcon: /*#__PURE__*/_jsx(FlagIcon, {
    className: "h-5 w-5"
  }),
  ClipboardDocumentCheckIcon: /*#__PURE__*/_jsx(ClipboardDocumentCheckIcon, {
    className: "h-5 w-5"
  }),
  ClipboardIcon: /*#__PURE__*/_jsx(ClipboardIcon, {
    className: "h-5 w-5"
  }),
  psychologist: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/psychologist.svg'),
    alt: ""
  }),
  transportation_card: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/transportation_card.svg'),
    alt: ""
  }),
  gym: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/gym.svg'),
    alt: ""
  }),
  dentist: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/dentist.svg'),
    alt: ""
  }),
  restaurant_discount: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/restaurant_discount.svg'),
    alt: ""
  }),
  workwear: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/workwear.svg'),
    alt: ""
  }),
  CarFront: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/car-front.svg'),
    alt: ""
  }),
  RestTimeSofa: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/rest-time-sofa-icon.svg'),
    alt: ""
  }),
  PartTimeClock: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/part-time-clock.svg'),
    alt: ""
  }),
  FullTimeClock: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/full-time-clock.svg'),
    alt: ""
  }),
  ItalyFlag: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/flags/italy.png'),
    alt: "",
    className: "h-5 w-5"
  }),
  FranceFlag: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/flags/france.png'),
    alt: "",
    className: "h-5 w-5"
  }),
  GermanFlag: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/flags/germany.png'),
    alt: "",
    className: "h-5 w-5"
  }),
  RussiaFlag: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/flags/russia.png'),
    alt: "",
    className: "h-5 w-5"
  }),
  UKFlag: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/flags/uk.png'),
    alt: "",
    className: "h-5 w-5"
  }),
  SpainFlag: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/flags/spain.png'),
    alt: "",
    className: "h-5 w-5"
  })
};
export var ratingIconMap = {
  'rating-currency-icon': /*#__PURE__*/_jsxs("g", {
    clipPath: "url(#clip0_214_8672)",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M44.9135 29.7874C49.5597 34.4336 49.5597 41.9666 44.9135 46.6127C40.2673 51.2589 32.7343 51.2589 28.0882 46.6127C23.442 41.9665 23.442 34.4336 28.0882 29.7874C32.7344 25.1412 40.2673 25.1412 44.9135 29.7874Z",
      stroke: "#693EB5",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M40.2768 41.978C38.1903 44.0646 34.8088 44.0646 32.7222 41.978C30.6356 39.8914 30.6356 36.5099 32.7222 34.4233C34.8088 32.3368 38.1903 32.3368 40.2768 34.4233",
      stroke: "#693EB5",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M36.5022 36.7256H30.0918",
      stroke: "#693EB5",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M36.5022 39.6746H30.0918",
      stroke: "#693EB5",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }),
  'rating-graph-icon': /*#__PURE__*/_jsx("g", {
    clipPath: "url(#clip0_219_8807)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M37.3333 29.3333H48M48 29.3333V40M48 29.3333L37.3333 40L32 34.6666L24 42.6666",
      stroke: "#693EB5",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }),
  'rating-clock-icon': /*#__PURE__*/_jsx("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M37 30v8h6m6 0a12 12 0 1 1-24 0 12 12 0 0 1 24 0",
    stroke: "#693EB5"
  }),
  'ellipse-image': '/ellipse-image.jpg'
};
export var ratingCorMap = {
  1: {
    x: 8,
    y: 50
  },
  2: {
    x: 6,
    y: 26
  },
  3: {
    x: 35,
    y: 4
  },
  4: {
    x: 66,
    y: 26
  },
  5: {
    x: 64,
    y: 50
  }
};